import styled from "styled-components";

export const MenuNotificationContainer = styled.div`
  background-color: #FFF;
  width: 265px;
  position: fixed;
  right: 0px;
  top: 80px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: #a5a3a3 0px 3px 5px 0px;
  border-radius: 0px 0px 0px 8px;
  transform: translateX(100%);
  transition: transform 0.6s ease;
  &.show {
    transform: translateX(0);
  }
`

export const MenuCounterNotifications = styled.div`
  min-height: 40px;
  padding: 8px 0px 8px 40px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  justify-content: start;
`

export const MenuCounterNotificationText = styled.span`
  font-size: 14px;
  color: #6c757d;
  text-align: center;
`

export const MenuNotificationItem = styled.div`
  display: flex;
  flex-direction: row;
  padding-block: 8px;
  border-top: 1px solid #cecece;
  &:hover {
    background-color: #f6f9ff;
    cursor: pointer;
  }
`

export const MenuNotificationIcon = styled.div`
  display: flex;
  align-items: center;
  width: 2.5rem;
  justify-content: center;
`

export const MenuNotificationBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const MenuNotificationTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
`

export const MenuNotificationContent = styled.div`
  font-weight: 400;
  font-size: 13px;
  color: #919191;
`

export const MenuNotificationTime = styled.div`
  font-weight: 400;
  font-size: 11px;
  color: #919191;
`


export const MenuNoNotifications = styled.div`
  border-top: 1px solid #cecece;
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  padding: 8px;
`